//internal
import { ResponseMeta } from '@app/typings/services/service.d';
import * as DeviceState from '@app/store/typings/state/device.d';

export const KEY_DEVICE_ZONE_RESET_DATA = 'KEY_DEVICE_ZONE_RESET_DATA';
export interface DeviceWithZoneResetData {
  type: typeof KEY_DEVICE_ZONE_RESET_DATA;
}

export const KEY_DEVICE_ZONE_FETCH = 'KEY_DEVICE_ZONE_FETCH';
export interface DeviceWithZoneFetch {
  type: typeof KEY_DEVICE_ZONE_FETCH;
  payload: {
    project: string;
    zone: string;
    reset?: string;
  };
}

export const KEY_DEVICE_ZONE_SET_DATA = 'KEY_DEVICE_ZONE_SET_DATA';
export interface DeviceWithZoneSetData {
  type: typeof KEY_DEVICE_ZONE_SET_DATA;
  payload: {
    zone: string;
    meta: ResponseMeta;
    data: any[];
  };
}

export const KEY_DEVICE_MODAL_ADD_LOCKER = 'KEY_DEVICE_MODAL_ADD_LOCKER';
export interface DeviceModalAddLocker {
  type: typeof KEY_DEVICE_MODAL_ADD_LOCKER;
  payload: {
    modal?: boolean;
  };
}

export const KEY_DEVICE_ADD_LOCKER = 'KEY_DEVICE_ADD_LOCKER';
export interface DeviceAddLocker {
  type: typeof KEY_DEVICE_ADD_LOCKER;
  payload: DeviceState.DeviceAssetLocker;
}

export const KEY_DEVICE_EDIT_LOCKER = 'KEY_DEVICE_EDIT_LOCKER';
export interface DeviceEditLocker {
  type: typeof KEY_DEVICE_EDIT_LOCKER;
  payload: {
    index: number;
    data: DeviceState.DeviceAssetLocker;
  };
}

export type DeviceType =
  | DeviceWithZoneResetData
  | DeviceWithZoneFetch
  | DeviceWithZoneSetData
  | DeviceModalAddLocker
  | DeviceAddLocker
  | DeviceEditLocker
  | DeviceCreate;
